module.exports = __webpack_public_path__ + "img/uncollect.bef79ed3.png";